const main = () => {
    if (document.querySelector('#page-estate-index') == null) return;

    document.querySelectorAll('select[name="sort"]').forEach((obj) => {
        obj.addEventListener('change', (e) => {
            const sort = e.currentTarget.value;
            document.querySelector(`button[name="sort"][value="${sort}"]`).click();
        });
    });
}

export default main;
